import { RootState } from 'store/types';
import { IBibleState, IBook } from 'store/slices/biblesSlice/types';

export const getBiblesState = (state: RootState): IBibleState => state.bibles;

export const getBook = (state: RootState): IBook => getBiblesState(state).book;
export const getChapter = (state: RootState): number => getBiblesState(state).chapter;
export const getVerse = (state: RootState): number => getBiblesState(state).verse;
export const getTranslations = (state: RootState): (number | string)[] => getBiblesState(state).translations;
